import { Button, Form, type FormProps, Input, Select, DatePicker, type FormInstance } from 'antd'
import dayjs from 'dayjs'

import { type CouponBody } from '@services/CouponService'

import type { Product } from '../../../../types'

type CouponFormProps = {
    form: FormInstance<any>
    onFinish: FormProps<CouponBody>['onFinish']
    availableProducts: Product[]
    isLoading: boolean
}

export const CouponForm = ({ form, onFinish, availableProducts, isLoading }: CouponFormProps) => {
    const today = dayjs().set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0)
    const oneWeekFromToday = today.add(1, 'week')

    return (
        <Form
            form={form}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 12 }}
            layout="horizontal"
            disabled={false}
            onFinish={onFinish}
        >
            <Form.Item label="Code" name="code" rules={[{ required: true, message: 'Please enter a code' }]}>
                <Input />
            </Form.Item>

            <Form.Item
                name="expiry"
                label="Expiry"
                rules={[{ required: true, message: 'Please select an expiry date' }]}
                initialValue={oneWeekFromToday}
            >
                <DatePicker />
            </Form.Item>

            <Form.Item
                label="Product"
                name="productId"
                rules={[{ required: true, message: 'Please select a product' }]}
            >
                <Select
                    style={{ minWidth: '200px' }}
                    options={availableProducts.map(ap => ({
                        label: ap.name,
                        value: ap.id,
                        color: 'green'
                    }))}
                />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type="primary" htmlType="submit" loading={isLoading}>
                    Submit
                </Button>
            </Form.Item>
        </Form>
    )
}
